import { defineComponent, computed, resolveComponent, createElementBlock, createBlock, createCommentVNode, openBlock, Fragment, renderSlot, normalizeProps, mergeProps, resolveDynamicComponent, withCtx } from 'vue';
import { hasProtocol } from './basler-components.es380.js';

const _hoisted_1 = ["href", "target", "rel", "download"];
const _hoisted_2 = ["href", "target", "rel", "download"];
const _hoisted_3 = ["href", "target", "rel"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HyperLink",
  props: {
    uri: {},
    external: { type: Boolean },
    target: {},
    rel: {},
    download: { type: Boolean },
    isRenderless: { type: Boolean },
    replace: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const isEmpty = computed(() => {
      if (typeof props.uri === "object") {
        return false;
      }
      return props.uri === "" || props.uri === void 0;
    });
    const isExternal = computed(() => {
      if (props.external) {
        return true;
      }
      if (props.target && props.target !== "_self") {
        return true;
      }
      if (component.value === "RouterLink") {
        return true;
      }
      if (typeof props.uri === "object") {
        return false;
      }
      const res = props.uri === "" || hasProtocol(props.uri ? props.uri : "", { acceptRelative: true });
      return res;
    });
    const useRel = computed(() => {
      let result = props.rel;
      if (!result && isExternal.value) {
        result = "noopener noreferrer";
      }
      return result;
    });
    const uriAsString = computed(() => {
      if (typeof props.uri === "object") {
        return "";
      }
      return props.uri ? props.uri : "";
    });
    const isStorybook = computed(() => {
      return undefined                               === "true";
    });
    const component = computed(() => {
      if (isStorybook.value) {
        return "a";
      }
      return resolveComponent("RouterLink");
    });
    return (_ctx, _cache) => {
      return isEmpty.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        !_ctx.isRenderless ? (openBlock(), createElementBlock("span", normalizeProps(mergeProps({ key: 0 }, _ctx.$attrs)), [
          renderSlot(_ctx.$slots, "default")
        ], 16)) : renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 64)) : isStorybook.value ? (openBlock(), createElementBlock("a", {
        key: 1,
        href: uriAsString.value,
        target: _ctx.target,
        rel: useRel.value,
        download: _ctx.download === true ? "" : void 0
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1)) : !isExternal.value ? (openBlock(), createBlock(resolveDynamicComponent(component.value), {
        key: 2,
        to: _ctx.uri,
        target: _ctx.target,
        rel: useRel.value,
        replace: _ctx.replace,
        download: _ctx.download === true ? "" : void 0
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to", "target", "rel", "replace", "download"])) : isExternal.value && _ctx.download ? (openBlock(), createElementBlock("a", {
        key: 3,
        href: uriAsString.value,
        target: _ctx.target,
        rel: useRel.value,
        download: _ctx.download === true ? "" : void 0
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_2)) : isExternal.value ? (openBlock(), createElementBlock("a", {
        key: 4,
        href: uriAsString.value,
        target: _ctx.target,
        rel: useRel.value
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_3)) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
